import store from '@store/index'
import Vue from "vue";

function AgencyGuard(to, from, next) {
  let user = store.getters['auth/user']

  if (!user) {
    next({ name: 'login' })
  } else if (user.role !== 'Agency') {
    next('/')
  } else if (!user.subscribed && !user.agency.free_fee) {
    if (to.name !== 'agency.subscription') {
      next({ name: 'agency.subscription' })
    } else {
      next()
    }
  } else {
    next()
  }
}

export default AgencyGuard
